// helpers.js

//import * as d3 from 'd3';

import { Api } from '../Api.js';

const helpers = {

    eventLog: function(this1) {
        let vals = this1.split(/ *\- */g); // " - " split
        let key = vals.shift();
        let key2 = encodeURIComponent("webapp:"+key);
        let vals2 = encodeURIComponent(JSON.stringify(vals))

        let url = "https://ikids-admin.reportback.org/report/survey?key="+key2+"&value="+vals2 + "&useapi=1"; //+"&access_code="+access_code;

        //d3.text(url); // old
        let thepromise = Api.getURL(url); // new
        // console.log("PROMISE")
        // console.log(thepromise);
        // console.log("eventLog('"+key+"')=>" + JSON.stringify(vals));
    },

    convertGroupName: function(name) {
        return name === "Sunscreen Chemicals" ? "sunscreen" : name.toLowerCase().replace(' ', '_');
    },

    findGetParameter: function(parameterName) {
        var result = null,
            tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        }
        return result;
      },

    localstorage2querystring: function() {
        var params = JSON.parse(JSON.stringify(window.localStorage));
        var queryString = Object.keys(params).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        }).join('&');
        return queryString;
      },

    houseORavatar: function(avatar, group) {
        return this.avatarName(avatar, group);
    },

    benchmarkName: function(chemicalGroup)
    {
        var bm = "us_median";  //default -- us.svg
        if (chemicalGroup === 'Water CVOCs' ) bm = "max_level"; // graph-blue-star.png
        if (chemicalGroup === 'Water Phthalates') bm = "";  // there is no benchmark
        return bm;
    },

    showVisitBadges: function(chemicalGroup) {
        return (chemicalGroup !== 'Water CVOCs' && chemicalGroup !== 'Water Phthalates');
    },

    avatarName: function(avatar, group) {
        return !this.showVisitBadges(group) ? 'house' : avatar;
    },

    getIconColor: function(group, intl) {
      let colors = {
        blue: "#39A9DB",
        yellow: "#F0C414",
        purple: "#801A86",
        green: "#618B25",
        red: "#D63230",
        orange: "#E9724C",
        pink: "#F14196",
        gray: "#949B96",
        brown: "#843B0B",
        black: "#000000",
      }

      let colorName = intl.messages['chemicals.' + group + '.color']
      let hexColor = intl.messages['chemicals.' + group + '.colorHex']

      if (!hexColor) { // the researcher didn't define a hex color
        if (colorName) { // the researcher defined a color name instead
          hexColor = colors[colorName]
        } else { // no color defined
          // need to get a unique index for this chemical;
          let allPages = Object.keys(intl.messages)
          let allGroups = []
          for (let i = 0; i < allPages.length; i++) {
            let page = allPages[i]
            if (page.includes("chemicals.") && page.includes(".title")) {
              allGroups.push(page)
            }
          }
          let index = 0;
          for (let i = 0; i < allGroups.length; i++) {
            if (allGroups[i].includes(group)) {
              index = i
            }
          }

          // now get the color with the key
          let autoColor = Object.keys(colors)[index]
          hexColor = colors[autoColor]
        }
      }
      return hexColor
    },

}

if (typeof window !== 'undefined') {
    window.helpers = helpers;
}

export default helpers;



// WEBPACK FOOTER //
// ./src/util/helpers.js